<template>
    <div class="filters-group">
        <div class="filters-group-label">{{title}}</div>
        <div class="filters-group-outer" v-bind:class="{active: model}">
            <label :for="type" class="filters-checkbox">
                {{buttonTitle}}
            </label>
            <input
                @change="showResultsButtonFn"
                :id="type"
                :value="value"
                v-model="model"
                type="checkbox"
                style="visibility: hidden">
        </div>
    </div>
</template>

<script>
export default {
    props: ['title', 'buttonTitle', 'type', 'value'],
    computed: {
        model: {
            get(){ return this.$store.state.search.filterData[this.$props.type] },
            set(value){ this.$store.commit("search/setFilterData", { type: this.$props.type, value }) }
        },
    },
    methods: {
        showResultsButtonFn() {
            this.$store.commit('search/updateSearchObject', { obj: 'showResultsButton', value: true })
        }
    }
}
</script>